// src/utils/storageSafe.js
export function hasLocalStorage() {
  try {
    const test = '__ls_test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (_) {
    return false;
  }
}

export function safeGetItem(key) {
  try {
    return localStorage.getItem(key);
  } catch (_) {
    return null;               // or whatever default you need
  }
}

export function safeSetItem(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (_) {/* ignore */}
}

export function safeRemoveItem(key) {
  try {
    localStorage.removeItem(key);
  } catch (_) {/* ignore */}
} 